 /**
 * Handle the behavior of the newsletter signup.
 */
const NewsletterSignup = {
	_processing: false,
	
	_init: () => {
		document.addEventListener('DOMContentLoaded', NewsletterSignup._ready);
	},
	_ready: () => {
		const newsletterSignup = document.getElementById('newsletter');
		newsletterSignup.addEventListener('submit', NewsletterSignup._newsletterSignupSubmitHandler);

		const newsletterRes = document.querySelectorAll('.newsletter-field-res');
		newsletterRes.forEach(res => res.addEventListener('click', NewsletterSignup._newsletterCloseHandler));
	},
	_hideFormElements: () => {
		document.querySelectorAll('.newsletter-names-input').forEach(input => input.style.display = 'none');
		document.querySelector('.newsletter-email-input').style.display = 'none';
		document.querySelector('.newsletter-field-button').style.display = 'none';
	},
	_showResult: (res) => {
		NewsletterSignup._hideFormElements();
		const resultField = document.querySelector(`.newsletter-field-res.${res.status === 200 ? 'success' : 'error'}`);
		if (resultField) {
			resultField.style.display = 'flex';
		}
	},
	_newsletterSignupSubmitHandler: async (e) => {
		e.preventDefault();
		
		//prevent multiple submissions
		if (NewsletterSignup._processing) return;
		NewsletterSignup._processing = true;
		
		const submitBtn = e.currentTarget.querySelector('.newsletter-field-button');
		if (submitBtn) submitBtn.disabled = true;
		
		try {
			let fetchurl = new URL(ajaxurl);
			const form = new FormData(e.currentTarget);
			form.append('action', 'newsletter_signup');

			let res = await fetch(fetchurl, {
				method: 'POST',
				body: form,
			})
			
			if (!res.ok) {
				console.error('Fetch failed:', res.status, res.statusText);
				NewsletterSignup._showResult({ status: 500 });
				return;
			}
			
			res = await res.json();

			if (res.status === 400 || res.status === 500) {
				NewsletterSignup._showResult(res);
			} else if (res.status === 200) {
				NewsletterSignup._showResult(res);
			}
		} catch (error) {
			console.error('Newsletter signup error:', error);
			NewsletterSignup._showResult({ status: 500 });
		} finally {
			NewsletterSignup._processing = false;
			if (submitBtn) submitBtn.disabled = false;
		}
	},
	_newsletterCloseHandler: (e) => {
		const newsLetter = document.getElementById('newsletter');
		newsLetter.reset();

		const newsletterRes = document.querySelectorAll('.newsletter-field-res');
		newsletterRes.forEach(res => {
			res.style.removeProperty('display');
			res.querySelector('.newsletter-field-res-close').style.removeProperty('display');
		});
		
		const newsletterNameInputs = document.querySelectorAll('.newsletter-names-input');
		const newsletterEmailInput = document.querySelector('.newsletter-email-input');
		newsletterNameInputs.forEach(input => input.style.removeProperty('display'));
		newsletterEmailInput.style.removeProperty('display');
		const newsletterButton = document.querySelector('.newsletter-field-button');
		newsletterButton.style.removeProperty('display');
	}
}
NewsletterSignup._init();
